import _ from "lodash";

export default class ProductServiceUtils {
  static getPerUnitCdOrInterestForDay(
    dayNumber,
    benefit,
    previousBenefitSlabEndDay
  ) {
    if (
      benefit?.benefitType === "PERCENTAGE" ||
      benefit?.benefitType === "ABSOLUTE"
    ) {
      let currentCdOrInterestPercentage = benefit?.benefitAmount;
      let perUnitCalculatedBenefitAmount =
        benefit?.perUnitCalculatedBenefitAmount;
      let DA = benefit?.depreciatingAmount;

      let depreciatingFactorCdOrInterest;
      if (currentCdOrInterestPercentage < 0) {
        // Interest case
        depreciatingFactorCdOrInterest =
          (dayNumber - previousBenefitSlabEndDay) * DA;
      } else {
        // Cash Discount case
        depreciatingFactorCdOrInterest =
          perUnitCalculatedBenefitAmount -
          (dayNumber - previousBenefitSlabEndDay - 1) * DA;
      }

      return depreciatingFactorCdOrInterest;
    } else {
      // only 2 types of CD entitlements are currently supported
      return null;
    }
  }

  static getPaymentPeriodStartDay(benefit) {
    if (benefit) {
      if (benefit?.paymentPeriod === "Advance") {
        return 0;
      } else if (benefit?.paymentPeriod?.startsWith(">")) {
        return parseInt(
          benefit?.paymentPeriod.replace(">", "").replace(" days", "").trim(),
          10
        );
      } else {
        const startDay = benefit?.paymentPeriod?.split("-")[0].trim();
        return parseInt(startDay, 10);
      }
    } else {
      return null;
    }
  }

  static parseDaysFromPaymentPeriodEndDay(paymentPeriodEndDay) {
    // accepts strings like "Advance", "2 Days", ">2 days" & returns the parsed day number
    if (paymentPeriodEndDay === "Advance") {
      return 0;
    }
    const match = paymentPeriodEndDay?.match(/\d+/);
    if (match) {
      return parseInt(match[0], 10);
    }
    return null;
  }

  static getDiscountBenefitByDay(dayNumber, discountBenefits) {
    // returns the benefit on the "dayNumber" from original "discountBenefits" list
    if (discountBenefits) {
      for (let i = 0; i < discountBenefits.length; i++) {
        const benefit = discountBenefits[i];
        const periodString = benefit?.paymentPeriod.trim();

        // Handle "Advance" case
        if (periodString.toLowerCase() === "advance") {
          // Check the next benefit's period to determine the end of the "advance" period
          const nextBenefit = discountBenefits?.[i + 1];
          if (nextBenefit) {
            const nextPeriodString = nextBenefit?.paymentPeriod.trim();

            if (nextPeriodString.includes("-")) {
              const [start] = nextPeriodString
                .split("-")
                .map((str) => parseInt(str.replace(/\D/g, "")));
              if (dayNumber < start) {
                return benefit;
              }
            } else if (nextPeriodString.startsWith(">")) {
              const startDay = parseInt(nextPeriodString.replace(/\D/g, ""));
              if (dayNumber < startDay) {
                return benefit;
              }
            } else {
              const exactDay = parseInt(nextPeriodString.replace(/\D/g, ""));
              if (dayNumber < exactDay) {
                return benefit;
              }
            }
          } else {
            // If no next period, treat "advance" as covering all remaining days
            return benefit;
          }
        }

        // Handle open-ended range (e.g., ">150 days")
        if (periodString.startsWith(">")) {
          const startDay = parseInt(periodString.replace(/\D/g, ""));
          if (dayNumber > startDay) {
            return benefit;
          }
        }

        // Handle range-based periods (e.g., "1-30 Days")
        if (periodString.includes("-")) {
          const [start, end] = periodString
            .split("-")
            .map((str) => parseInt(str.replace(/\D/g, "")));
          if (dayNumber >= start && dayNumber <= end) {
            return benefit;
          }
        }

        // Handle exact day number (e.g., "30 Days")
        if (!periodString.includes("-")) {
          const exactDay = parseInt(periodString.replace(/\D/g, ""));
          if (dayNumber === exactDay) {
            return benefit;
          }
        }
      }
    }

    return null;
  }

  static splitObjectByPaymentPeriod(arr, splitDay) {
    // takes the last object in the array, splits it into 2 objects by "splitDay"
    // resultant array has last 2 objects with payment period as "x to splitDay" and "splitDay+1 to y" respectively
    const clonedArr = _.cloneDeep(arr);
    const lastObj = clonedArr?.[clonedArr?.length - 1];
    const [startDay, endDay] = lastObj?.paymentPeriod
      ?.match(/\d+/g)
      ?.map(Number);

    if (splitDay < startDay || splitDay >= endDay) {
      return null;
    }

    const firstObj = _.cloneDeep({
      ...lastObj,
      value: splitDay,
      label: `>${splitDay - 1}`,
      paymentPeriod: `${startDay}-${splitDay} Days`,
      paymentPeriodEndDay: `${splitDay} Days`,
    });
    const secondObj = _.cloneDeep({
      ...lastObj,
      value: endDay,
      paymentPeriod: `${splitDay + 1}-${endDay} Days`,
      paymentPeriodEndDay: `${endDay} Days`,
    });

    clonedArr[clonedArr?.length - 1] = firstObj;
    clonedArr.push(secondObj);
    return clonedArr;
  }
}
